<template>
  <div class="tab-content tab-tech-specs">
    <el-form ref="form" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="20">
          <el-collapse v-model="activeSections">
            <!-- <el-collapse-item title="TECH SPEC CATEGORY" name="category">
              <el-row :gutter="15">
                <el-col :span="12">
                  <el-form-item label="Spec">
                    <el-input v-model="techSpecs.category.spec"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Sub-spec">
                    <el-input v-model="techSpecs.category.sub_spec"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item> -->
            <el-collapse-item title="BASICS" name="basics">
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Interface">
                    <el-checkbox-group v-model="techSpecs.basic.interface">
                      <el-checkbox label="XLR analog" :disabled="techSpecs.basic.interface.includes('AES digital')"></el-checkbox>
                      <el-checkbox label="USB digital" :disabled="techSpecs.basic.interface.includes('AES digital')"></el-checkbox>
                      <el-checkbox label="AES digital" :disabled="['XLR analog', 'USB digital'].includes(techSpecs.basic.interface[0])"></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Category">
                    <el-radio v-model="techSpecs.basic.category" label="analog">analog</el-radio>
                    <el-radio v-model="techSpecs.basic.category" label="digital modelling">digital modelling</el-radio>
                    <el-radio v-model="techSpecs.basic.category" label="digital">digital</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Type">
                    <el-radio v-model="techSpecs.basic.type" label="condenser">condenser</el-radio>
                    <el-radio v-model="techSpecs.basic.type" label="dynamic">dynamic</el-radio>
                    <el-radio v-model="techSpecs.basic.type" label="ribbon">ribbon</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Diaphragm Class" v-if="['condenser', 'dynamic'].includes(techSpecs.basic.type)">
                    <el-radio v-model="techSpecs.basic.diaphragm_class" label="large">large</el-radio>
                    <el-radio v-model="techSpecs.basic.diaphragm_class" label="medium">medium</el-radio>
                    <el-radio v-model="techSpecs.basic.diaphragm_class" label="small">small</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Ribbon Class" v-if="techSpecs.basic.type === 'ribbon'">
                    <el-radio v-model="techSpecs.basic.ribbon_class" label="large">large</el-radio>
                    <el-radio v-model="techSpecs.basic.ribbon_class" label="small">small</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Amplifier">
                    <el-checkbox-group v-model="techSpecs.basic.amplifier">
                      <el-checkbox label="Tube"></el-checkbox>
                      <el-checkbox label="Solid State"></el-checkbox>
                      <el-checkbox label="FET"></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Power">
                    <el-radio v-model="techSpecs.basic.power" label="+48v">+48v</el-radio>
                    <el-radio v-model="techSpecs.basic.power" label="external power supply included">external power supply included</el-radio>
                    <el-radio v-model="techSpecs.basic.power" label="passive">passive</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Pattern">
                    <el-input placeholder="cardioid only" v-model="techSpecs.basic.pattern.cardioid"></el-input>
                    <el-input placeholder="hypercardioid only" v-model="techSpecs.basic.pattern.hypercardioid"></el-input>
                    <el-input placeholder="figure-8 only" v-model="techSpecs.basic.pattern.figure_8"></el-input>
                    <el-input placeholder="omni only" v-model="techSpecs.basic.pattern.omni"></el-input>
                    <el-input placeholder="multipattern" v-model="techSpecs.basic.pattern.multipattern"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
            </el-collapse-item>
            <el-collapse-item title="AMPLIFIER & TRANSFORMER" name="amp_tra">
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Amplifier">
                    <el-checkbox-group v-model="techSpecs.amp_tra.amplifier">
                      <el-checkbox label="Tube"></el-checkbox>
                      <el-checkbox label="Solid State"></el-checkbox>
                      <el-checkbox label="FET"></el-checkbox>
                    </el-checkbox-group>
                    <el-form-item label="Tube Type" v-if="(techSpecs.amp_tra.amplifier).includes('Tube')">
                      <el-input v-model="techSpecs.amp_tra.tube_type"></el-input>
                    </el-form-item>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Transformer">
                    <el-checkbox-group v-model="techSpecs.amp_tra.transformer">
                      <el-checkbox label="Transformerless" :checked="techSpecs.amp_tra.transformer" @change="transformerClick"></el-checkbox>
                    </el-checkbox-group>
                    <el-row :gutter="15">
                      <el-col :span="12">
                        <el-form-item label="Made by" v-if="!techSpecs.amp_tra.transformer">
                              <el-input v-model="techSpecs.amp_tra.manufacturer"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Part Name" v-if="!techSpecs.amp_tra.transformer && techSpecs.amp_tra.manufacturer">
                              <el-input v-model="techSpecs.amp_tra.part_name"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="CAPSULE & DIAPHRAGM" name="cap_dia">
              <el-row :gutter="15">
                <el-col :span="12">
                  <el-form-item label="Capsule style">
                    <el-input v-model="techSpecs.cap_dia.capsule_style"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Capsule size in mm">
                    <el-input v-model="techSpecs.cap_dia.capsule_size"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Capsule Materials">
                    <el-input v-model="techSpecs.cap_dia.capsule_materials"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Termination">
                    <el-input v-model="techSpecs.cap_dia.termination"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Diaphragm size in mm">
                    <el-input v-model="techSpecs.cap_dia.diaphragm_size"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Diaphragm materials">
                    <el-input v-model="techSpecs.cap_dia.diaphragm_materials"  maxlength=30></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="PATTERNS" name="patterns">
              <el-form-item label="Type">
                <el-radio v-model="techSpecs.patterns.selection" label="Cardioid">Cardioid</el-radio>
                <el-radio v-model="techSpecs.patterns.selection" label="Omni">Omni</el-radio>
                <el-radio v-model="techSpecs.patterns.selection" label="Figure-8">Figure-8</el-radio>
                <el-radio v-model="techSpecs.patterns.selection" label="Hypercardioid">Hypercardioid</el-radio>
                <el-radio v-model="techSpecs.patterns.selection" label="Multi-Pattern">Multi-Pattern</el-radio>
              </el-form-item>
              <el-form-item label="Multi Patterns" v-if="techSpecs.patterns.selection === 'Multi-Pattern'">
                <el-radio v-model="techSpecs.patterns.multi_pattern" label="continuously variable">continuously variable</el-radio>
                <el-radio v-model="techSpecs.patterns.multi_pattern" label="stepped">stepped</el-radio>
                <el-radio v-model="techSpecs.patterns.multi_pattern" label="specific patterns">specific patterns</el-radio>
                <el-radio v-model="techSpecs.patterns.multi_pattern" label="software controlled">software controlled</el-radio>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item title="CONTROLS (PADS, FILTERS, MODES)" name="controls">
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Pattern Selector" v-if="techSpecs.patterns.selection === 'Multi-Pattern'">
                    <el-radio v-model="techSpecs.controls.pattern_selector" label="on mic">on mic</el-radio>
                    <el-radio v-model="techSpecs.controls.pattern_selector" label="on power supply">on power supply</el-radio>
                    <el-radio v-model="techSpecs.controls.pattern_selector" label="software controlled">software controlled</el-radio>
                  </el-form-item>
                </el-col>
                </el-row>
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-form-item label="Pad(s) in dB">
                      <el-input v-model="techSpecs.controls.pad"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="High Pass in Hz">
                      <el-input v-model="techSpecs.controls.high_pass"></el-input>
                    </el-form-item>
                  </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Other Filter">
                    <el-input v-model="techSpecs.controls.other_filter" maxlength=21></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Modes">
                    <el-input v-model="techSpecs.controls.modes"  maxlength=40></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item label="Special Controls">
                    <el-input v-model="techSpecs.controls.special_controls"  maxlength=21></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="DATA" name="data">
              <el-row :gutter="15">
                <el-col :span="12">
                  <el-form-item label="Output Impedance in ohms">
                    <el-input v-model="techSpecs.data.output_impedance"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Frequency Range">
                    <el-input v-model="techSpecs.data.frequency_range"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Self-noise in dB A">
                    <el-input v-model="techSpecs.data.self_noise"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Max SPL in dB">
                    <el-input v-model="techSpecs.data.max_spl"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Signal to Noise Ratio in dB(A)">
                    <el-input v-model="techSpecs.data.signal_to_noise_ratio"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="PHYSICAL" name="physical">
              <el-row :gutter="15">
                <el-col :span="12">
                  <el-form-item label="Weight in g">
                    <el-input v-model="techSpecs.physical.weight"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Height in mm">
                    <el-input v-model="techSpecs.physical.height"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Max Diameter in mm">
                    <el-input v-model="techSpecs.physical.max_diameter"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateProduct" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: 'TabTechSpecs',
  props: {
    tab: String,
    tabUpdate: Boolean,
    role: String,
    actionItem: Object
  },
  emits: ['changeSaveTab'],
  components: {
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    return {
      activeSections: ['basics'],
      product: {},
      techSpecs: {
        basic: {
          interface: [],
          category: '',
          type: '',
          diaphragm_class: '',
          ribbon_class: '',
          amplifier: [],
          power: '',
          pattern: {}
        },
        amp_tra: {
          amplifier: [],
          tube_type: '',
          transformer: false,
          manufacturer: '',
          part_name: ''
        },
        cap_dia: {
          capsule_style: '',
          capsule_size: undefined,
          capsule_materials: '',
          termination: '',
          diaphragm_size: undefined,
          diaphragm_materials: ''
        },
        patterns: {
          selection: '',
          multi_pattern: ''
        },
        controls: {
          pattern_selector: '',
          pad: undefined,
          high_pass: undefined,
          other_filter: '',
          modes: '',
          special_controls: ''
        },
        data: {
          output_impedance: undefined,
          frequency_range: undefined,
          self_noise: undefined,
          max_spl: undefined,
          signal_to_noise_ratio: undefined
        },
        physical: {
          weight: undefined,
          height: undefined,
          max_diameter: undefined
        }
      },
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.product = { ...val }
          if (val && val.tech_specs) this.techSpecs = { ...this.techSpecs, ...val.tech_specs }
        }
      },
      deep: true
    },
    tabUpdate: {
      handler: function (val, oldVal) {
        if (val !== oldVal && val && this.tab === 'Tech Specs') {
          this.updateProduct()
          this.$emit('changeSaveTab', '')
        }
      },
      deep: true
    }
  },
  methods: {
    transformerClick: function () {
      const flag = this.techSpecs.amp_tra.transformer
      this.techSpecs.amp_tra.transformer = !flag
    },
    updateProduct: function () {
      this.$emit('changeSaveTab', '')
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/products/${this.product._id}`
      const that = this
      const body = { type: 'tech_specs', content: this.techSpecs }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateProduct', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    triggerTabUpdate: function () {
      this.$emit('changeSaveTab', 'Tech Specs')
    }
  }
}
</script>

<style lang="scss">
.tab-tech-specs {
  .el-collapse-item__header {
    background-color: #F2F2F2;
    padding: 0 10px;
  }
}
</style>
